import { OnInit, EventEmitter } from '@angular/core';
import { MatTableDataSource, MatSort } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MenuService } from '../../shared/header/menu/menu.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { UtilService } from '@app/shared/utils';
var SearchResultContainerComponent = /** @class */ (function () {
    function SearchResultContainerComponent(route, menuService, breakpointObserver, util) {
        this.route = route;
        this.menuService = menuService;
        this.breakpointObserver = breakpointObserver;
        this.util = util;
        this.displayedColumns = ['idUser'];
        this.dataSource = new MatTableDataSource(this.dataSource);
        this.pageSizeOptions = [10, 20, 50];
        this.searchTermChange = new EventEmitter();
    }
    SearchResultContainerComponent.prototype.ngOnInit = function () {
        /*this.paginator.page.subscribe((event)=> {
          console.log(event);
        });
        this.dataSource.paginator = this.paginator;*/
        var _this = this;
        this.dataSource.sort = this.sort;
        this.route.paramMap.pipe(switchMap(function (params) {
            _this.searchTerm = params.get('searchTerm');
            return of(_this.searchTerm);
        })).subscribe(function (query) {
            _this.getSearchResults(query);
        });
        //this.adjustTabIndexPaginator();
    };
    SearchResultContainerComponent.prototype.getSearchResults = function (query) {
        var _this = this;
        try {
            this.searchResults = this.menuService.filterMenu(query);
            this.searchTermChange.emit({ searchTerm: query, itemCount: this.searchResults.length });
            this.dataSource = new MatTableDataSource(this.searchResults);
            /*this.dataSource.paginator = this.paginator;*/
            setTimeout(function () {
                _this.util.requestFocusOnFirstOcurrence("resultSearchLink");
                //this.adjustTabIndexPaginator();
            });
        }
        catch (_a) { }
    };
    Object.defineProperty(SearchResultContainerComponent.prototype, "paginatorLength", {
        /*adjustTabIndexPaginator(){
          let buttonPaginatorPrevious = this.util.getFirstElememtByClassName("mat-paginator-navigation-previous");
          if(buttonPaginatorPrevious){
            buttonPaginatorPrevious.tabIndex=this.initialTabindex;
          }
      
          let buttonPaginatorNext = this.util.getFirstElememtByClassName("mat-paginator-navigation-next");
          if(buttonPaginatorNext){
            buttonPaginatorNext.tabIndex=this.initialTabindex;
          }
      
          let pageSizePaginator = this.util.getFirstElememtByClassName("mat-select");
          if(pageSizePaginator){
            pageSizePaginator.tabIndex=this.initialTabindex;
          }
        }*/
        get: function () {
            return this.dataSource.data.length;
        },
        enumerable: true,
        configurable: true
    });
    return SearchResultContainerComponent;
}());
export { SearchResultContainerComponent };
